<div [formGroup]="form">
  <select *ngIf="field.editable" class="form-control" [formControlName]="field.alias" type="" [attr.disabled]="disabled ? '' : null" [id]="'ba-'+ field.alias">
    <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
  </select>
  <div *ngIf="!field.editable">
    {{ fieldValue }}
  </div>
</div>
